import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import {
  RelayControllerStatus,
  relayControllerStatusSchema,
} from '@sophocles/entities/RelayControllerStatus/relayControllerStatusRecord';
import apiClient, { vantageApiClient } from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_RELAY_CONTROLLER_STATUSES = 'RECEIVE_RELAY_CONTROLLER_STATUSES';
function receiveRelayControllerStatuses(json) {
  return {
    type: RECEIVE_RELAY_CONTROLLER_STATUSES,
    relayControllerStatuses: mapListToRecords(json, RelayControllerStatus),
  };
}

/* Request Actions */
// starter request
export const REQUEST_RELAY_CONTROLLER_STATUS = 'REQUEST_RELAY_CONTROLLER_STATUS';
function requestRelayControllerStatus(relayControllerStatus_id) {
  return {
    type: REQUEST_RELAY_CONTROLLER_STATUS,
    relayControllerStatus_id,
  };
}

export const REQUEST_RELAY_CONTROLLER_STATUS_FOR_UNIT = 'REQUEST_RELAY_CONTROLLER_STATUS_FOR_UNIT';
function requestRelayControllerStatusForUnit(unit_id) {
  return {
    type: REQUEST_RELAY_CONTROLLER_STATUS_FOR_UNIT,
    unit_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchRelayControllerStatus(relayControllerStatus_id) {
  return dispatch => {
    dispatch(requestRelayControllerStatus(relayControllerStatus_id));
    return apiClient
      .get(`/relaycontrollerstatus/${relayControllerStatus_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'relayControllerStatuses', relayControllerStatusSchema))
      .then(json => dispatch(receiveRelayControllerStatuses(json.entities.relayControllerStatuses)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_RELAY_CONTROLLER_STATUS));
      });
  };
}
function normalizeVantageRespones(rawJson, unit_id) {
  const normalizedResponse = {
    results: [
      {
        id: rawJson.smartlink_unit,
        last_receive_time: rawJson.last_receive_time,
        relay_controller: unit_id,
        ...rawJson.status,
      },
    ],
  };
  return normalizedResponse;
}
/*** ONE  **/
export function fetchRelayControllerStatusForUnit(unit_id, isVantage) {
  const client = isVantage ? vantageApiClient : apiClient;
  let url = `/relaycontrollerstatus/?relay_controller=${unit_id}`;
  if (isVantage) {
    url = `/stat/packets/${unit_id}/`;
  }

  if (isVantage) {
    return dispatch => {
      dispatch(requestRelayControllerStatusForUnit(unit_id));
      return client
        .get(url)
        .then(checkHttpStatus)
        .then(response => normalizeVantageRespones(response.data, unit_id))
        .then(response => normalizeList(response.results, 'relayControllerStatuses', relayControllerStatusSchema))
        .then(json => dispatch(receiveRelayControllerStatuses(json.entities.relayControllerStatuses)))
        .catch(error => {
          dispatch(genericErrorAction(error, REQUEST_RELAY_CONTROLLER_STATUS));
        });
    };
  }
  return dispatch => {
    dispatch(requestRelayControllerStatusForUnit(unit_id));
    return client
      .get(url)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'relayControllerStatuses', relayControllerStatusSchema))
      .then(json => dispatch(receiveRelayControllerStatuses(json.entities.relayControllerStatuses)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_RELAY_CONTROLLER_STATUS));
      });
  };
}

/* Edit Actions */
export const EDIT_RELAY_CONTROLLER_STATUS = 'EDIT_RELAY_CONTROLLER_STATUS';
export function editRelayControllerStatus(relayControllerStatus_id) {
  return {
    type: EDIT_RELAY_CONTROLLER_STATUS,
    relayControllerStatus: relayControllerStatus_id,
  };
}

export function patchRelayControllerStatus(relayControllerStatus_id, values) {
  return dispatch => {
    dispatch(editRelayControllerStatus(relayControllerStatus_id));
    return apiClient
      .patch(`/relaycontrollerstatus/${relayControllerStatus_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, relayControllerStatusSchema))
      .then(json => {
        dispatch(receiveRelayControllerStatuses(json.entities.relayControllerStatuses));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, EDIT_RELAY_CONTROLLER_STATUS));
      });
  };
}

/* Create Actions */
export const CREATE_RELAY_CONTROLLER_STATUS = 'CREATE_RELAY_CONTROLLER_STATUS';
function sayCreateRelayControllerStatus(values) {
  return {
    type: CREATE_RELAY_CONTROLLER_STATUS,
    values: values,
  };
}

export function createRelayControllerStatus(values) {
  return dispatch => {
    dispatch(sayCreateRelayControllerStatus(values));
    return apiClient
      .post(`/relaycontrollerstatus/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, relayControllerStatusSchema))
      .then(json => {
        dispatch(receiveRelayControllerStatuses(json.entities.relayControllerStatuses));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, CREATE_RELAY_CONTROLLER_STATUS));
      });
  };
}

/* Delete Actions */
export const DELETE_RELAY_CONTROLLER_STATUS = 'DELETE_RELAY_CONTROLLER_STATUS';
function sayDeleteRelayControllerStatus(relayControllerStatus_id) {
  return {
    type: DELETE_RELAY_CONTROLLER_STATUS,
    relayControllerStatus: relayControllerStatus_id,
  };
}

export function deleteRelayControllerStatus(relayControllerStatus_id) {
  return dispatch =>
    apiClient
      .delete(`/relaycontrollerstatus/${relayControllerStatus_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteRelayControllerStatus(relayControllerStatus_id)))
      .catch(error => {
        dispatch(genericErrorAction(error, DELETE_RELAY_CONTROLLER_STATUS));
      });
}

const receiver = (dispatch, json) => dispatch(receiveRelayControllerStatuses(json.entities.relayControllerStatuses));

export const handleRelayControllerStatusSocketActions = websocketsHandlerFactory(
  receiver,
  sayDeleteRelayControllerStatus,
  relayControllerStatusSchema,
);
